import React, {Component} from 'react';
import axios from 'axios';
import InsuranceItem from './misc/InsuranceItem';
import {phoneNumberMask, states, dateMask } from '../utilities';
import moment from 'moment';

import Loader from '../elements/Loader'

class Registerch extends Component {
  constructor(props){
    super(props);
    this.state = {
      lastName: '',
      firstName: '',
      dob: '',
      gender: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      email: '',
      confirmEmail: '',
      phone: '',
      passport: '',
      insuranceID: '',
      policy: '',
      isInsurance: '',
      submitted: false,
      insurance: '',
      insuranceID: '',
      policy: '',
      otherInsuranceInfo: {
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: ''
      },
      relationToInsured: '',
      guarantor: {
        lastName: '',
        firstName: '',
        dob: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
      },
      errors: [],
      fileBase64: '',
      isFileUploading: false,
      fileType: '',
      test: '',
      isAnswered: true,
      question1: '',
      question2: '',
      question3: '',
      question4: '',
      question5: '',
      question6: '',
      question7: '',
      question8: '',
      isValidAnswer: true,
      loading: false,
      error: '',
      consent: false,
      agree: false,
    }
  }

  onChangeOtherInsurance = (key, value, e) => {
    if(key === 'phone'){
      value = phoneNumberMask(value)
    } else {
      value = value.toUpperCase();
    }
    let newInsurance = {...this.state.otherInsuranceInfo};
    newInsurance[key] = value;
    this.setState({otherInsuranceInfo: newInsurance, insurance: value})
  }

  onChangeGuarantor = (key, value, e) => {
    if(key === 'dob'){
      value = dateMask(value)
    } else if(key === 'phone'){
      value = phoneNumberMask(value)
    } else {
      value = value.toUpperCase();
    }
    let newGuarantor = {...this.state.guarantor};
    newGuarantor[key] = value;
    this.setState({guarantor: newGuarantor})
  }

  handleChange = (key, value, e) => {
    this.setState({[key]: value})
  }

  onChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if(name === 'phone'){
      value = phoneNumberMask(value)
    }
    if(name === 'dob'){
      value = dateMask(value)
    }
    this.setState({
      [name]: value
    })
  }

  onSelectInsurance = (id, name) => {
    this.setState({insuranceID: id, insurance: name})
  }

  register = () => {
    this.setState({
      loading: true
    })
    let formData = {};
    formData.guarantor = this.state.guarantor;
    formData.clientID = this.props.match.params.id;
    formData.otherInsuranceInfo = this.state.otherInsuranceInfo;

    formData.question1 = this.state.question1;
    formData.question2 = this.state.question2; 
    formData.question3 = this.state.question3; 
    formData.question4 = this.state.question4; 
    formData.question5 = this.state.question5; 
    formData.question6 = this.state.question6; 
    formData.question7 = this.state.question7; 
    formData.question8 = this.state.question8; 

    let errors = [];
    if (this.state.lastName){
      formData.lastName = this.state.lastName;
    } else {
      errors.push("姓是必需的")
    }

    if (this.state.passport){
      formData.passport = this.state.passport;
    }

    if (this.state.firstName){
      formData.firstName = this.state.firstName;
    } else {
      errors.push("名字是必需的")
    }

    if (this.state.dob && moment(this.state.dob, 'MM/DD/YYYY').isValid()){
      formData.dob = this.state.dob;
    } else {
      errors.push("请输入有效的出生日期")
    }

    if (this.state.gender){
      formData.gender = this.state.gender;
    } else {
      errors.push("性别是必需的")
    }

    if (this.state.address){
      formData.address = this.state.address;
    } else {
      errors.push("需要地址")
    }

    if (this.state.city){
      formData.city = this.state.city;
    } else {
      errors.push("城市是必需的")
    }

    if (this.state.state){
      formData.state = this.state.state;
    } else {
      errors.push("国家是必需的")
    }

    if (this.state.zip){
      formData.zip = this.state.zip;
    } else {
      errors.push("需要ZIP")
    }

    if (this.state.email){
      if (this.state.confirmEmail) {
        if (this.state.confirmEmail === this.state.email){
          formData.email = this.state.email;
        } else {
          errors.push("电子邮件和确认电子邮件不匹配")
        }
      } else {
        errors.push("请确认电邮")
      }       
    } else {
      if (this.state.phone){
        formData.email = "";
      } else {
        errors.push("电子邮件或电话是必需的")
      }      
    }

    if (this.state.phone){
      formData.phone = this.state.phone;
    } else {
      if (this.state.email){
        formData.phone = "";
      }  
    }     

    if (this.state.isInsurance){
      if (this.state.isInsurance === '1'){
        if (this.state.policy){
          formData.policy = this.state.policy;
        } else {
          errors.push("政策是必需的")
        }
        if (this.state.insurance){
          formData.insurance = this.state.insurance;
        } else {
          errors.push("须提供保险名称")
        }
        if (this.state.relationToInsured){
          formData.relationToInsured = this.state.relationToInsured;
          if (this.state.relationToInsured === 'Self'){
            formData.guarantor = {
              lastName: this.state.lastName,
              firstName: this.state.firstName,
              dob: this.state.dob,
              address: this.state.address,
              city: this.state.city,
              state: this.state.state,
              zip: this.state.zip,
              phone: this.state.phone,
            }
          } else {
            if (this.state.guarantor.lastName){
              formData.guarantor.lastName = this.state.guarantor.lastName;
            } else {
              errors.push("需要担保人姓氏")
            }
        
            if (this.state.guarantor.firstName){
              formData.guarantor.firstName = this.state.guarantor.firstName;
            } else {
              errors.push("需要担保人的名字")
            }
        
            if (this.state.guarantor.dob){
              formData.guarantor.dob = this.state.guarantor.dob;
            } else {
              errors.push("保证人出生日期是必需的")
            }
        
            if (this.state.guarantor.address){
              formData.guarantor.address = this.state.guarantor.address;
            } else {
              errors.push("需要担保人地址")
            }
        
            if (this.state.guarantor.city){
              formData.guarantor.city = this.state.guarantor.city;
            } else {
              errors.push("担保城市是必需的")
            }
        
            if (this.state.guarantor.state){
              formData.guarantor.state = this.state.guarantor.state;
            } else {
              errors.push("担保国是必需的")
            }
        
            if (this.state.guarantor.zip){
              formData.guarantor.zip = this.state.guarantor.zip;
            } else {
              errors.push("需要担保人ZIP")
            }
        
            if (this.state.guarantor.phone){
              formData.guarantor.phone = this.state.guarantor.phone;
            } else {
              errors.push("需要担保人电话")
            }
          }
        } else {
          errors.push("需要与被保险人的关系")
        }
        formData.insuranceID = this.state.insuranceID;
        formData.otherInsuranceInfo = this.state.otherInsuranceInfo;
      }      
    } else {
      errors.push("你有保险吗？")
    }

    if (this.state.fileBase64){
      // formData.fileBase64 = ''
      formData.fileBase64 = this.state.fileBase64;
      formData.fileType = this.state.fileType;
    } else {
      errors.push("需要您的身份证照片")
    }

    // if (this.state.test){
    //   formData.test = this.state.test;
    // } else {
    //   errors.push("Select a test")
    // }

    if (!this.state.consent){
      errors.push("请确认你已阅读同意书")
    }

    if (errors.length){
      this.setState({
        errors: errors,
        loading: false,
      })
    } else {
      axios({
        method: 'POST',
        url: `${process.env.REACT_APP_URL}/registration`,
        data: formData,
      }).then(res => {
        console.log(res)
        if (res.data.err){
          this.setState({
            error: res.data.err,
            lastName: '',
            firstName: '',
            dob: '',
            gender: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            insuranceID: '',
            policy: '',
            isInsurance: '',
            insurance: '',
            insuranceID: '',
            policy: '',
            otherInsuranceInfo: {
              name: '',
              address: '',
              city: '',
              state: '',
              zip: '',
              phone: ''
            },
            relationToInsured: '',
            guarantor: {
              lastName: '',
              firstName: '',
              dob: '',
              address: '',
              city: '',
              state: '',
              zip: '',
              phone: '',
            },
            fileBase64: '',
            fileType: '',
            test: '',
            errors: [],
            isAnswered: true,
            question1: '',
            question2: '',
            question3: '',
            question4: '',
            question5: '',
            question6: '',
            question7: '',
            question8: '',
            loading: false,
            consent: false,
          })
        } else {
          this.setState({
            submitted: true,
            lastName: '',
            firstName: '',
            dob: '',
            gender: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            insuranceID: '',
            policy: '',
            isInsurance: '',
            insurance: '',
            insuranceID: '',
            policy: '',
            otherInsuranceInfo: {
              name: '',
              address: '',
              city: '',
              state: '',
              zip: '',
              phone: ''
            },
            relationToInsured: '',
            guarantor: {
              lastName: '',
              firstName: '',
              dob: '',
              address: '',
              city: '',
              state: '',
              zip: '',
              phone: '',
            },
            fileBase64: '',
            fileType: '',
            test: '',
            errors: [],
            isAnswered: false,
            question1: '',
            question2: '',
            question3: '',
            question4: '',
            question5: '',
            question6: '',
            question7: '',
            question8: '',
            loading: false,
            consent: false,
          })
        }        
      }).catch(err => {
        console.log(err)
      })
    }
  }

  back = () => {
    this.setState({
      submitted: false,
      error: '',
    })
  }

  onFileUpload = (event) => {
    const reader = new FileReader();
    const file = event.target.files[0];
    const newState = {...this.state};


    reader.onloadend = () => {
      newState.fileBase64 = reader.result;
    };
    
    reader.readAsDataURL(file);

    this.setState({
      isFileUploading: true,
      isValid: false,
    }, () => {
      const checkReadyState = setInterval(() => {
        console.log(reader)
        let file = newState.fileBase64.split(';base64')[0];
        newState.fileType = file.split('/')[1]
        console.log(newState.fileType)
        if (reader.readyState === 2) {
          clearInterval(checkReadyState);
          this.setState(newState);
        }
      }, 1000);
    });
  }

  answer = () => {
    let isValid = true;
    let validAnswer = false;
    if (!this.state.question1){
      isValid = false;
    } else {
      if (this.state.question1 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question2){
      isValid = false;
    } else {
      if (this.state.question2 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question3){
      isValid = false;
    } else {
      if (this.state.question3 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question4){
      isValid = false;
    } else {
      if (this.state.question4 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question5){
      isValid = false;
    } else {
      if (this.state.question5 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question6){
      isValid = false;
    } else {
      if (this.state.question6 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question7){
      isValid = false;
    } else {
      if (this.state.question7 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question8){
      isValid = false;
    } else {
      if (this.state.question8 === '1'){
        validAnswer = true;
      }
    }
    console.log(validAnswer)
    if (isValid && validAnswer){
      this.setState({
        isAnswered: true,
        errors: [],

      })
    } else if (isValid && !validAnswer){
      this.setState({
        isValidAnswer: false,
      })
    } else {
      let errors = ['Please answer all the questions']
      this.setState({
        errors: errors
      })
    }
  }

  changeAnswer = () => {
    this.setState({
      isValidAnswer: true
    })
  }

  handleConsent = (e) => {
    this.setState({
      consent: !this.state.consent
    })
  }

  consent = () => {
    window.open(`${process.env.REACT_APP_URL_API || ''}/v0/consent`)
  }

  agree = () => {
    this.setState({
      agree: true
    })
  }

  renderForm(){
    return(
      <div>
        <h3>歡迎來到帝國城實驗室</h3>
        <form className="form m-t" role="form">
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='輸入您的名字' 
              required='required'
              name="firstName" 
              value={this.state.firstName} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='輸入您的姓氏' 
              required='required'
              name="lastName" 
              value={this.state.lastName}   
              onChange={this.onChange}/>
          </div>              
          <div className="form-group">
            <label>出生日期</label>
            <input className="form-control input-sm" 
              type='text' 
              placeholder='月/日/年' 
              required='required'
              name="dob" 
              value={this.state.dob} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <select className="form-control input-sm" name="gender" value={this.state.gender} onChange={this.onChange}>
              <option value="">选择性别</option>
              <option value="F">女性</option>
              <option value="M">男性</option>
              <option value="U">不想回答</option>
            </select>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='輸入您的地址' 
              required='required'
              name="address" 
              value={this.state.address} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='輸入您的城市' 
              required='required'
              name="city" 
              value={this.state.city} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <select className="form-control input-sm" name="state" value={this.state.state} onChange={this.onChange}>
              <option value="">Select State</option>
              {states.map(item => 
                <option key={item.abbreviation} value={item.abbreviation}>{item.name}</option>
              )}
            </select>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
            type='text' 
            placeholder='輸入您的郵編' 
            required='required'
            name="zip" 
            value={this.state.zip} 
            onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='輸入你的電子郵箱' 
              required='required' 
              name="email" 
              value={this.state.email} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='確認您的電子郵件' 
              required='required' 
              name="confirmEmail" 
              value={this.state.confirmEmail} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
            type='text' 
            placeholder='輸入您的電話' 
            required='required' 
            name="phone" 
            value={this.state.phone} 
            onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='您的護照號碼（可選）' 
              required='required' 
              name="passport" 
              value={this.state.passport} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <select className="form-control input-sm" name="isInsurance" value={this.state.isInsurance} onChange={this.onChange}>
              <option value="">你有保險嗎？</option>
              <option value="0">非也。</option>
              <option value="1">是的</option>
            </select>
          </div>
          {this.state.isInsurance && this.state.isInsurance !== '0' ? 
            <InsuranceItem 
              name={this.state.insurance} 
              id={this.state.insuranceID} 
              policy={this.state.policy} 
              relationToInsured={this.state.relationToInsured}
              guarantor={this.state.guarantor}
              onChangeGuarantor={this.onChangeGuarantor}
              onSelectInsurance={this.onSelectInsurance} 
              otherInsuranceInfo={this.state.otherInsuranceInfo}
              onChangeOtherInsurance={this.onChangeOtherInsurance}
              onChange={this.handleChange}
            /> : null
          } 
          <div className="form-group">
            <label className="iblock">
              <span tabIndex="0" className={`btn btn-sm btn-block ${this.state.fileBase64 && !this.state.isFileUploading ? 'btn-success' : 'btn-default'}`}>
                {
                  this.state.isFileUploading ?
                    <span><i className="fa fa-spinner fa-pulse fa-fw" /> Uploading...</span>
                  :
                  this.state.fileBase64 ?
                    <span><i className="fa fa-check" /> 上传的文件</span>
                  :
                  <span><i className="fa fa-search" /> 上傳您的身份證件</span>
                }
              </span>
              <input type="file" className="hidden" onChange={this.onFileUpload} value="" />
            </label>
          </div>  
        </form>
        {this.state.errors ? 
          <ul style={{color: 'red', fontWeight: 'bold', listStyle: 'none', textAlign: 'left'}}>
            {this.state.errors.map((item, index) => <li key={index}>{item}</li>)}
          </ul> : null
        }
        <a onClick={this.consent}><h3 style={{textDecoration: "underline"}}>患者同意書</h3></a>
        <input type="checkbox" name="consent" value={this.state.consent} checked={this.state.consent} onChange={this.handleConsent}/> 我承認我已閱讀上面的患者同意書。
        <button className="btn block btn-primary full-width m-b" onClick={this.register}>{this.state.loading ? <Loader/> : '我已閱讀患者知情同意書。'}</button>
        <p className="m-t"><small>&copy; 2008-2021帝国城市实验室有限公司 版权所有。 ECL和Empire City Laboratories是Empire City Laboratories ® ,Inc的注册商标</small></p>
      </div> 
    )
  }

  renderQuestions(){
    if (this.state.isValidAnswer){
      return(
        <div>
          <h3>歡迎來到帝國城實驗室</h3> 
          <form className="form m-t" role="form">
            <div className="form-group">
              <label>1) 您是否正在寻找一个测试，以防止COVID-19的可能传播为未来的旅行或娱乐（根据疾病预防控制中心的指导方针）？</label>
              <select className="form-control input-sm" name="question1" value={this.state.question1} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>2) 你是否正在寻找一个测试，以防止COVID-19的可能传播后，在一个地方，社会距离是不可能的？</label>
              <select className="form-control input-sm" name="question2" value={this.state.question2} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>3) 你有没有和一个有COVID-19确诊病例的人有过密切的联系?</label>
              <select className="form-control input-sm" name="question3" value={this.state.question3} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>4) 您是否居住在一个特殊的环境中，COVID-19传播的风险可能很高？</label>
              <select className="form-control input-sm" name="question4" value={this.state.question4} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>5) 你从事医疗工作吗?</label>
              <select className="form-control input-sm" name="question5" value={this.state.question5} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>6) 您是否在COVID-19传播风险可能很高的特殊环境中工作？</label>
              <select className="form-control input-sm" name="question6" value={this.state.question6} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>7) 你是否被要求或转介接受医疗服务提供者的测试？</label>
              <select className="form-control input-sm" name="question7" value={this.state.question7} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>8) 你在过去14天有没有出现任何症状？</label>
              <select className="form-control input-sm" name="question8" value={this.state.question8} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
          </form>
          {this.state.errors ? 
            <ul style={{color: 'red', fontWeight: 'bold', listStyle: 'none', textAlign: 'left'}}>
              {this.state.errors.map((item, index) => <li key={index}>{item}</li>)}
            </ul> : null
          }
          <button className="btn block btn-primary full-width" onClick={this.answer}><i className="fa fa-check"></i> 我承认我已经回答了 <br/>这些问题如实地做到最好 <br/>就我所知。</button>
          <p className="m-t"><small>&copy;2008-2021帝国城市实验室有限公司 版权所有。 ECL和Empire City Laboratories是Empire City Laboratories ® ,Inc.的注册商标。</small></p>
        </div>
      )
    } else {
      return(
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div style={{textAlign: 'center'}}>
            <h3 className="font-bold" style={{fontSize: '18pt', lineHeight: '30px'}}>
              根据您提供的信息，目前不建议您进行测试。
            </h3>
            <br/>
            <br/><br/>
            <button className="btn btn-primary" onClick={this.changeAnswer}>Back</button>
          </div>
        </div>
      )
    }    
  }

  render(){
    if (!this.state.agree) {
      return(
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div style={{textAlign: 'center'}}>
            <h3>
              <span style={{color: 'red'}}>请注意:</span> 我们不再能够为没有保险的病人提交COVID-19索赔. 卫生资源和服务管理局（HRSA）的COVID-19无保险计划通知我们，他们将从2022年3月22日起停止接受索赔。 我们将不能再为无保险的病人提交COVID-19测试的索赔。 但是，对于希望支付测试费用的无保险患者，仍然可以进行测试。
            </h3>
            <button className="btn btn-primary" onClick={this.agree}>同意</button>
          </div>
        </div>
      )
    } else if (this.state.submitted){
      return (
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div style={{textAlign: 'center'}}>
            <h1 className="font-bold" style={{fontSize: '18pt', lineHeight: '30px'}}>感谢您的注册！</h1>
            <br/>
            <i className="fa fa-thumbs-up modal-icon modal-icon-warning" style={{fontSize: '100pt'}}></i>
            <br/><br/>
            <button className="btn btn-primary" onClick={this.back}>Back</button>
          </div>
        </div>
      )
    } else if(this.state.error){
      return(
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div style={{textAlign: 'center'}}>
            <h1 className="font-bold" style={{fontSize: '18pt', lineHeight: '30px'}}>{this.state.error}</h1>
            <br/>
            <i className="fa fa-warning modal-icon modal-icon-danger" style={{fontSize: '100pt'}}></i>
            <br/><br/>
            <button className="btn btn-primary" onClick={this.back}>返回</button>
          </div>
        </div>
      )      
    } else {
      return(
        <div className="middle-box text-center loginscreen animated fadeInDown">
          {this.renderForm()}
        </div>
      )
    }    
  }
}
export default Registerch